// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useAppStore } from 'store/modules/appStore';
// uuid
import { v4 as uuidv4 } from 'uuid';

const FINGERPRINT_STORAGE_KEY = 'app_fingerprint_id';

/**
 * 获取指纹
 * 指纹ID存储到store中，优先从localStorage缓存中获取
 */
export default async function useFingerprint() {
    try {
        const appStore = useAppStore();
        
        // 先检查localStorage中是否已有指纹ID
        let visitorId: string = localStorage.getItem(FINGERPRINT_STORAGE_KEY) || '';
        
        if (!visitorId) {
            visitorId = uuidv4();
            // 存储到localStorage
            localStorage.setItem(FINGERPRINT_STORAGE_KEY, visitorId);
        } 
        // 设置到store中
        appStore.setFingerprintId(visitorId);
    } catch (error) {
        console.error('get fingerprint error:', error);
    }
}
